import React, { useState } from 'react';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
  sizes?: string;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  width,
  height,
  loading = 'lazy',
  priority = false
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  // If image fails to load, show placeholder
  if (imageError) {
    return (
      <div 
        className={`bg-gray-200 flex items-center justify-center ${className}`}
        style={{ 
          width: width ? `${width}px` : '100%',
          height: height ? `${height}px` : '200px',
          aspectRatio: width && height ? `${width}/${height}` : undefined
        }}
      >
        <span className="text-gray-500 text-sm">Image not available</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? 'eager' : loading}
      decoding="async"
      fetchPriority={priority ? 'high' : 'auto'}
      className={`w-full h-full object-cover ${className}`}
      style={{
        aspectRatio: width && height ? `${width}/${height}` : undefined,
        minHeight: height ? `${height}px` : undefined
      }}
      onError={handleImageError}
    />
  );
};

// Hero image component with priority loading
export const HeroImage: React.FC<OptimizedImageProps> = (props) => (
  <OptimizedImage 
    {...props} 
    loading="eager" 
    priority={true}
  />
);

// Gallery image component with lazy loading
export const GalleryImage: React.FC<OptimizedImageProps> = (props) => (
  <OptimizedImage 
    {...props} 
    loading="lazy" 
  />
);

// Service card image component
export const ServiceImage: React.FC<OptimizedImageProps> = (props) => (
  <OptimizedImage 
    {...props} 
    loading="lazy" 
  />
);